import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { useLogout } from "hooks/auth/";

export type SuccessorSettings = {
  isConfigured: boolean;
  email: string | null;
  canViewFiles: boolean;
  isActive: boolean;
};

type ApiResponse = {
  status: "success";
  data: SuccessorSettings;
};

type UseGetSuccessorOpts = {
  autoLogoutOnAuthError?: boolean;
} & Partial<UseQueryOptions<ApiResponse, unknown, SuccessorSettings>>;

export function useGetSuccessor(options?: UseGetSuccessorOpts) {
  const { mutate: logout } = useLogout({});
  const {
    autoLogoutOnAuthError = true,
    ...rqOverrides
  } = options || {};

  return useQuery<ApiResponse, unknown, SuccessorSettings>({
    queryKey: ["succession", "settings"],
    queryFn: async () => {
      try {
        const res = await axiosInstance.get<ApiResponse>("successors/me");
        return res.data;
      } catch (err: any) {
        const status = err?.response?.status;
        if (autoLogoutOnAuthError && (status === 401 || status === 403)) {
          logout();
        }
        throw err;
      }
    },
    select: (data) => data.data,
    staleTime: 10_000,
    retry: 0,
    ...rqOverrides,
  });
}
